//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"ActiveViewColor",1,0],[0,"AssociativeAlignment",1,0],[0,"BorderColor",1,0],[0,"BreakLineAmplitude",1,0],[0,"BreakLineColor",1,0],[0,"BreakLineExtension",1,0],[0,"BreakLineGap",1,0],[0,"BreakLineType",1,0],[0,"BreakLineWidth",1,0],[0,"BreakLinesVisibility",1,0],[0,"Color",1,0],[0,"CustomSymbolSmashToSketch",1,0],[0,"DelayUpdateOnCreation",1,0],[0,"DelayViewUpdate",1,0],[0,"Delimiter",1,0],[0,"DisplayBorders",1,0],[0,"EnableSmoothEdgesForLWView",1,0],[0,"Font",1,0],[0,"FrameBarPrecision",1,0],[0,"FrameBarTicDirection",1,0],[0,"InitialSecondaryNumber",1,0],[0,"InitialSheetNumber",1,0],[0,"LineAntialiasing",1,0],[0,"MinimumComponentsForLargeAssemblyOption",1,0],[0,"PropagateBreakLines",1,0],[0,"RetainAnnotations",1,0],[0,"ShowFacetEdges",1,0],[0,"Translucency",1,0],[0,"UpdateViewWithoutLwData",1,0],[0,"VersionObjects",1,0],[0,"ViewStyle",1,0],[0,"ViewTracking",1,0],[0,"Width",1,0]],[],[]];
SPLM.Preferences.PartDrafting = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartDrafting";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartDrafting.ViewStyleType = Object.freeze({
    "Border" : "Border", "Wireframe" : "Wireframe", "HiddenWireframe" : "HiddenWireframe", "Shaded" : "Shaded"});

SPLM.Preferences.PartDrafting.FontType = Object.freeze({
    "Original" : "Original", "Invisible" : "Invisible", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Preferences.PartDrafting.WidthType = Object.freeze({
    "Original" : "Original", "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "ThicknessOne" : "ThicknessOne", "ThicknessTwo" : "ThicknessTwo", "ThicknessThree" : "ThicknessThree", "ThicknessFour" : "ThicknessFour", "ThicknessFive" : "ThicknessFive", "ThicknessSix" : "ThicknessSix", "ThicknessSeven" : "ThicknessSeven", "ThicknessEight" : "ThicknessEight", "ThicknessNine" : "ThicknessNine"});

SPLM.Preferences.PartDrafting.BreakLineStyle = Object.freeze({
    "Existing" : "Existing", "Simple" : "Simple", "Straight" : "Straight", "Sawtooth" : "Sawtooth", "LongBreak" : "LongBreak", "Tubular" : "Tubular", "SolidTubular" : "SolidTubular", "SolidRod" : "SolidRod", "Jigsaw" : "Jigsaw", "Wood" : "Wood"});

SPLM.Preferences.PartDrafting.UpdateViewWithoutLwDataOption = Object.freeze({
    "Ignore" : "Ignore", "Notify" : "Notify", "DoNotNotify" : "DoNotNotify", "Generate" : "Generate"});

export default SPLM;